import React from "react"
import styled from "styled-components"
import { graphql, useStaticQuery, Link } from "gatsby"

import {
  CreateLocalLink,
  getInverseColour,
  getColorLuminance,
} from "../../utils"
import getFlexiOptionsLayouts from "../../options/getFlexiOptionsLayouts"
import getFlexiOptionsBranding from "../../options/getFlexiOptionsBranding"

///////////////////////////////////////
// 🛠 Component
///////////////////////////////////////
const CategoryNavigation = ({ active }) => {
  const { primaryColor, lightSkin } = getFlexiOptionsBranding()

  const {
    wpgraphql: {
      categories: { nodes },
    },
  } = useStaticQuery(CATEGORIES)

  const {
    websiteSkeleton: { mainBgColor },
  } = getFlexiOptionsLayouts()

  return (
    <Wrapper
      primaryColor={primaryColor}
      lightSkin={lightSkin}
      mainBgColor={mainBgColor}
    >
      {nodes.map((cat, i) => (
        <Link
          to={CreateLocalLink(cat.link)}
          key={i}
          className={`${cat.slug === active ? "active" : ""}`}
        >
          {cat.name}
        </Link>
      ))}
    </Wrapper>
  )
}
export default CategoryNavigation

///////////////////////////////////////
// 💅 Styles
///////////////////////////////////////
const Wrapper = styled.div`
  margin-top: 40px;
  a {
    display: block;
    border: none;
    color: ${({ theme, lightSkin }) =>
      lightSkin ? theme.colors.midnight[100] : theme.colors.tusk[400]};
    background: ${({ theme, lightSkin, mainBgColor }) =>
      mainBgColor
        ? getColorLuminance(mainBgColor, 0.2)
        : lightSkin
        ? theme.colors.tusk[100]
        : theme.colors.midnight[100]};
    box-shadow: 0 10px 23px 0 rgba(0, 0, 0, 0.05);
    padding: 12px 15px;
    margin: 2px 0;
    border-radius: 2px;
    text-transform: capitalize;
    &:hover {
      cursor: pointer;
      border: none;
      color: ${({ primaryColor }) => getInverseColour(primaryColor)};
      background-color: ${({ primaryColor }) => primaryColor};
    }
    &.active {
      color: ${({ primaryColor }) => getInverseColour(primaryColor)};
      background-color: ${({ primaryColor }) => primaryColor};
    }
  }
`

///////////////////////////////////////
// 🔎 Queries
///////////////////////////////////////
const CATEGORIES = graphql`
  {
    wpgraphql {
      categories {
        nodes {
          link
          slug
          name
        }
      }
    }
  }
`
